import { useTranslation } from "react-i18next";
import RedirectingComponent from "src/chamber/components/RedirectingComponent";
import { Box } from "@mui/system";

type badgeCountsESignature = {
  activeViolationCasesApplications: number | null;
  assignChamberAdminDashboard: number | null;
  countsLoading?: boolean;
};

function ESignatureRedirector(props: badgeCountsESignature) {
  const { t } = useTranslation();

  const redirectors = [
    {
      linkText: t("Αιτήματα που έχουν ανατεθεί σε εμένα"),
      linkTo: "/beneficiary/representativesRequestsForChamber?mode=own",
      badgeCount: props.activeViolationCasesApplications,
      badgeLoading: props.countsLoading,
    },
    {
      linkText: t(
        "Αιτήματα Προσθήκης Νόμιμων Εκπροσώπων",
      ),
      linkTo: "/beneficiary/representativesRequestsForChamber?mode=all",
      badgeCount: props.assignChamberAdminDashboard,
      badgeLoading: props.countsLoading,
    },
  ];

  return (
    <Box
      sx={{
        padding: "1rem",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {redirectors.map((redirector) => (
        <RedirectingComponent filters={[]} {...redirector} />
      ))}
    </Box>
  );
}

export default ESignatureRedirector;
